import { useState, useEffect } from 'react';
import { Swiper } from 'antd-mobile';
import { getBannerList } from './api';
import './style/bannerStyle.scss';
import { getAliyunImg } from 'src/utils/utils'
export default function Banner() {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    // 加载轮播图数据
    const loadBanners = async () => {
        setLoading(true);
        try {
            const response = await getBannerList({
                pageIndex: 1,
                pageSize: 50 // 写大一点，获取所有轮播图
            });

            if (response && response.ok && response.data.Items) {
                setBanners(response.data.Items);
            }
        } catch (error) {
            console.error('加载轮播图失败:', error);
        } finally {
            setLoading(false);
        }
    };

    // 初始加载
    useEffect(() => {
        loadBanners();
    }, []);

    // 处理轮播图点击
    const handleBannerClick = (banner) => {
        if (banner.link_url) {
            // 如果是外部链接
            if (banner.link_url.startsWith('http://') || banner.link_url.startsWith('https://')) {
                window.location.href = banner.link_url;
            } else {
                // 如果是内部路由
                window.location.href = banner.link_url;
            }
        }
    };

    // 如果没有轮播图数据，不显示轮播图
    if (!loading && banners.length === 0) {
        return null;
    }

    return (
        <div className="banner-container">
            {loading ? (
                <div className="banner-loading">
                    <div className="banner-skeleton" />
                </div>
            ) : (
                <Swiper
                    loop
                    autoplay
                    autoplayInterval={3000}
                    indicator={(total, current) => (
                        <div className="banner-indicators">
                            {Array.from({ length: total }).map((_, index) => (
                                <div
                                    key={index}
                                    className={`banner-dot ${current === index ? 'active' : ''}`}
                                />
                            ))}
                        </div>
                    )}
                >
                    {banners.map((banner) => (
                        <Swiper.Item key={banner.id}>
                            <div
                                className="banner-slide"
                                onClick={() => handleBannerClick(banner)}
                            >
                                <img
                                    src={getAliyunImg(banner.image)}
                                    alt={banner.title || '轮播图'}
                                    className="banner-image"
                                />
                            </div>
                        </Swiper.Item>
                    ))}
                </Swiper>
            )}
        </div>
    );
}